<template>
    <div class="edit-comp pad-fix">
        <div v-if="competition" class="container">
            <p-tabs class="bit-down-c" v-model="activetab">
                <p-tab-item>
                    <template slot="header">
                        <span class="is-uppercase">Details</span>
                    </template>
                    <div class="columns">
                        <div class="column is-two-thirds">
                            <b-field label="Competition Name">
                                <b-input v-model="competition.name" size="is-medium" required type="text" placeholder="Enter Competition Name" />
                            </b-field>
                        </div>
                        <div class="column">
                            <b-field label="Competition Code">
                                <div class="comp-code-go">
                                    <div>
                                        <div class="the-code is-size-3">{{competition.key}}</div>
                                        <!--<b-icon class="darker" type="is-light" icon="content-copy"></b-icon>&nbsp;-->
                                        <div><router-link :to="`/${competition.key}`">https://ScoreRecorder.com/{{competition.key}}</router-link></div>
                                    </div>
                                    <span class="help-dot" @click="helpactive=true"><i class="mdi mdi-help mdi-18px"></i></span>
                                </div>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-one-third">
                            <b-field label="Type">
                                <input :value="comptypes[competition.competitionTypeTemplateId].label" class="input is-medium" readonly type="text" />
                            </b-field>
                        </div>
                        <div class="column"></div>
                    </div>
                </p-tab-item>
                <p-tab-item>
                    <template slot="header">
                        <span class="is-uppercase">Competitors</span>
                    </template>
                    <add-competitors @dosavechanges="savechanges" :competition="competition" v-on:showscoretab="activetab=1"></add-competitors>
                </p-tab-item>
                <p-tab-item>
                    <template slot="header">
                        <span class="is-uppercase">Rounds</span>
                    </template>
                    <edit-rounds></edit-rounds>
                </p-tab-item>
                <p-tab-item>
                    <template slot="header">
                        <span class="is-uppercase">Results</span>
                    </template>
                    <h1 class="title v-pad has-text-centered">Results Here</h1>
                </p-tab-item>
                <p-tab-item>
                    <template slot="header">
                        <span class="is-uppercase">Downloads</span>
                    </template>
                    <h1 class="title v-pad has-text-centered">Download It All</h1>
                </p-tab-item>

            </p-tabs>
        </div>
        <b-modal :active.sync="helpactive" class="b-help-modal">
            <div v-if="competition" class="help-modal">
                <div class="help-example">
                    <span class="the-code is-size-3">{{competition.key}}</span>
                    <div>scorerecorder.com/{{competition.key}}</div>
                </div>
                <p class="help-desc">
                    Enter this KEY in the box on ScoreRecorder.com to go straight to scoring or results.  
                </p>
                <p>Share it with competitors and spectators!</p>
                <b-field class="help-buttons"><b-button type="is-info" size="is-large" @click="helpactive=false">Ok</b-button></b-field>
            </div>
        </b-modal>
    </div>
</template>

<style>
</style>


<script>
//import axios from 'axios';
import PTabs from '../../../tabs/Tabs.vue'
import PTabItem from '../../../tabs/TabItem.vue'
import AddCompetitors from './AddCompetitors.vue'
import EditRounds from './EditRounds.vue'
import axios from 'axios';

export default {
    name: 'EditComp',
    components: { 
        AddCompetitors, PTabs, PTabItem, EditRounds, //RadioMenu
    },
    mounted()  {

    },
    data: function() {
        return {
            errors: [],
            activetab: 0,
            comptypes: [
                { label: '', value: 0 },
                    { label: 'Gymnastics', value: 1 },
                    { label: 'Rock Climbing', value: 2 },
                    //{ label: 'Triathlon', value: 3 }
                ]
            ,
            helpactive: false
        }
    },
    methods: {
        savechanges() {
            axios.post(`/api/competitions/${this.competition.id}`, this.competition)
            .then(res => {
                if (res.error) {
                    this.errors.push(res.error);
                } else {
                    console.log('Saved Ok')
                }
            }).catch(e => { this.errors.push(e) })
        }
    },
    computed: {
        competition() {
            return this.$store.getters['backend/competition']
        }
    },
    props: {

    }
}
</script>
<style>
    .comp-code-go {
        display: flex;
        align-items: center;
    }
</style>

